import React from "react";

interface MenuItemProps {
	title: string;
	href: string;
	setIsMobileMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
	onMobileMenuToggle?: boolean | React.Dispatch<React.SetStateAction<boolean>>;
}

const MobileMenuItem: React.FC<MenuItemProps> = ({
	title,
	href,
	setIsMobileMenuOpen,
	onMobileMenuToggle
}) => {

	const smoothScrollToSection = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
		e.preventDefault();
		setIsMobileMenuOpen(false);
		if (onMobileMenuToggle) {
			(onMobileMenuToggle as React.Dispatch<React.SetStateAction<boolean>>)(false);
		}
		document
			.getElementById(href.substring(1)) // Remove the '#' from href
			?.scrollIntoView({ behavior: "smooth" });
	};

	return (
		<li>
			<a
				href={href}
				className="text-gray-700 hover:text-primary-500 transition-colors font-karla"
				onClick={smoothScrollToSection}
			>
				{title}
			</a>
		</li>
	);
}


export default MobileMenuItem;